export default "__VITE_ASSET__DHxLFFmq__"